import API from '../States/API';
import Twilio from '../States/Twilio';
import {writable} from 'svelte/store';

const content = {id: false, details: {name: '', mail: '', company: '', phone: '', location: '', initials: '', lastCalled: '', blocked: false}, timeline: [], edit: false};
let contact = writable(content);

contact.search = async (search) => {
	const response = await API.request('get', `contact/search?search=${search}`, false, false)
	return response;
}

contact.save = async (form) => {
	const response = await API.request('post', `contact/${content.id}`, {content: form}, false)
	if(response.success) {
		content.name = form.name
		content.mail = form.mail
		content.company = form.company
		content.phone = form.phone
		content.location = form.location
		content.blocked = form.blocked
	}
	return response;
}

contact.list = async (id) => {
	const response = await API.request('get', `contact/list`)
	return response;
}

contact.get = async (id) => {
	const response = await API.request('get', `contact/${id}`)
	if(response.success) {
		content.id = id;
		content.details = response.contact
		content.timeline = response.timeline
		contact.set(content);
	}
	return response;
}

contact.setEdit = async (state) => {
	content.edit = state;
	contact.set(content);
}

contact.call = async () => {
	await Twilio.callNumber(content.details.phone);
}

contact.join = async (conferenceName) => {
	if(conferenceName)
		await Twilio.connect(false, conferenceName);
}

export default contact;